var ControlRegistrationParamsSerialiser = require('services/control/control-registration-params-serialiser');
var ConversationIDSerialiser = require('conversation/conversation-id-serialiser');

var serialiser = {
    read : function(input) {
        var params = ControlRegistrationParamsSerialiser.read(input);
        var cid = ConversationIDSerialiser.read(input);

        return {
            params : params,
            cid : cid
        };
    },
    write : function(output, request) {
        ControlRegistrationParamsSerialiser.write(output, request.params);
        ConversationIDSerialiser.write(output, request.cid);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/control-registration-request-serialiser.js
// module id = 477
// module chunks = 1